import { Col, Flex, Row, Select, Skeleton, Space, Tag } from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Text,
  Title,
} from "Components/CommonComponents/GeneralComponents";
import { returnStatusColor } from "./QuestionsTable";
import { ToastContextDispatch } from "Context/CommonContext";
import { CloseOutlined } from "@ant-design/icons";
import { ModalBodyInfo } from "../QuestionPreview";
import "./index.css";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import PropTypes from "prop-types";
import { languageArray } from "utilFunctions/Constants/Constants";

const QuestionSlider = (props) => {
  const { question, closeQuesContentSlider, mode = "questionMain" } = props;
  const ToastDispatch = useContext(ToastContextDispatch);
  const [questionContentLoader, setQuestionContentLoader] = useState(false);
  const [questionContent, setQuestionContent] = useState(null);
  const [selectedLangContent, setSelectedLangContent] = useState(null);
  const [languageOption, setLanguageOption] = useState([
    { value: "en", label: "English" },
  ]);
  const [regexOption, setRegexOption] = useState(null);

  const [selectedLanguage, setSelectedLangage] = useState("en");
  const fetchQuestionDetails = async (question) => {
    let id = question.questionId;
    let url =
      BASE_URL + "question/getBasicDetailsByQuestionId?questionId=" + id;
    getAPIRequest({
      url,
      success: (data) => {
        console.log(data);
      },
      failure: (data) => {
        if (data["code"] == "429") {
          if (data["message"] == "max_limit_reached") {
            ToastDispatch({
              isOpen: true,
              type: "Error",
              message: "Limit Exceeded",
            });
          }
        }
      },
    });
  };
  const fetchQuestionContent = async (question) => {
    let id = question.questionId;
    let url = BASE_URL + "questionLanguage?questionId=" + id;
    setQuestionContentLoader(true);
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        if (
          [
            "MATRIX",
            "SAT",
            "SAN",
            "SAD",
            "MCMCQ",
            "SCMCQ",
            "ASSR",
            "MATCHLIST",
            "Scenario",
            "QSTEM",
            "TF",
          ].includes(question.questionType) &&
          Array.isArray(data["data"])
        ) {
          const availableLangugae = data["data"].map((el) => el.language);
          const filterdLangaugeOption = languageArray.filter((el) =>
            availableLangugae.includes(el.value)
          );
          setLanguageOption(filterdLangaugeOption);
          const _m = data["data"].find((l) => l.language == "en");
          setSelectedLangContent(_m);
          setRegexOption(_m.question.regex);
        }
        setQuestionContent(data["data"] || [{ language: "en" }]);
        setQuestionContentLoader(false);
      },
      failure: (data) => {
        setQuestionContentLoader(false);
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: data["message"] || data["msg"],
        });
      },
    });
  };
  useEffect(() => {
    fetchQuestionDetails(question);
    fetchQuestionContent(question);
    setSelectedLangage("en");
  }, [question.questionId]);
  const handleChange = (value) => {
    setSelectedLangage(value);
    const filteredQuesLangContent = questionContent.filter(
      (el) => el.language == value
    );
    setSelectedLangContent(filteredQuesLangContent[0]);
  };
  const routeToQuestion = () => {
    // window.open(`/#/admin/questions-beta/${ques.questionId}`, "_blank");
  };
  return (
    <>
      <Row
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
      >
        <Col className="gutter-row" span={16}>
          <Row>
            <Col span={24}>
              <Flex
                vertical={false}
                justify={"flex-start"}
                align={"center"}
                onClick={() => {
                  routeToQuestion(question);
                }}
              >
                <Title level={5}>
                  Question Id:
                  <span className="tableIdStyle"> {question?.questionId}</span>
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Flex vertical={false} justify={"flex-start"} align={"center"}>
                <Text className="QuestionSliderMetaInfoCSS">
                  {question?.questionType} |&nbsp;
                </Text>
                <Text className="QuestionSliderMetaInfoCSS">
                  {question?.marks} marks |&nbsp;&nbsp;
                </Text>
                <Tag
                  color={returnStatusColor(question.questionStatus)}
                  key={question.questionStatus}
                >
                  {question.questionStatus}
                </Tag>
              </Flex>
            </Col>
          </Row>
        </Col>
        <Col span={8}>
          <Flex
            vertical={false}
            gap="small"
            justify={"flex-end"}
            align={"center"}
          >
            <Select
              value={selectedLanguage}
              style={{ width: 120 }}
              onChange={handleChange}
              options={languageOption}
            />
            <Button
              ghost
              type="text"
              size="small"
              shape="circle"
              icon={<CloseOutlined />}
              onClick={closeQuesContentSlider}
            ></Button>
          </Flex>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="gutter-row" span={24}>
          {questionContentLoader || selectedLangContent == null ? (
            <>
              <Space>
                <Skeleton active={true} paragraph={{ rows: 4 }} />
                <br />
                <Skeleton active={true} paragraph={{ rows: 4 }} />
              </Space>
            </>
          ) : (
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <ModalBodyInfo
                  mode={mode}
                  question={selectedLangContent}
                  questionType={question?.questionType}
                  regex={regexOption}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

QuestionSlider.propTypes = {
  question: PropTypes.any,
  closeQuesContentSlider: PropTypes.any,
  mode: PropTypes.string,
};
export default QuestionSlider;
